export default __webpack_public_path__ + "static/media/Icon11_On.2d3f8d95.png";